import { Geotab } from "@fairfleet/geotab";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";

export default function addFeedback(
  geotabClient: Geotab,
  deviceId: string,
  eventId: string,
  valid: boolean,
) {
  return geotabClient.call("Add", {
    typeName: "Feedback",
    entity: {
      device: {
        id: deviceId,
      },
      feedbackStatus: valid ? "Valid" : "Dismissed",
      feedbackTargetId: eventId,
      feedbackType: "collisionDetection",
      submittedOn: new Date().toISOString(),
    },
  });
}

export function useAddFeedback(deviceId: string, eventId: string) {
  const { geotabClient } = useGeotabClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (valid: boolean) => addFeedback(geotabClient, deviceId, eventId, valid),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["feedback"],
      });
    },
    onError: error => {
      console.error("Failed to update add-in:", error);
    },
  });
}
